<template>
    <van-popup v-model:show="show" round position="right" @click-overlay="() => close()" :style="{
        width: '65%',
        minHeight: '100%',
        background: '#3b372b',
        backgroundColor: '#221b24',
        zIndex: '10002',
    }">
        <div class="popupContainer">
            <van-row class="title" style="display: flex; justify-content: center; align-items: center;">
                <van-col span="3">
                    <img src="@/assets/themetwo/back.png" alt="" @click="close">
                </van-col>
                <van-col span="21" style="display: flex; justify-content: center; align-items: center;">
                    {{ $t('profile.ContactService') }}
                </van-col>
            </van-row>
            <div class="serviceCard" v-for="(item, index) in dataSet?.serviceList" :key="index">
                <van-row>
                    <van-col span="4" class="avatarImage">
                        <img :src="item.avatar" alt="">
                    </van-col>
                    <van-col span="12" class="serviceTitle">{{ item.nickname }}</van-col>
                    <van-col span="8" style="display: flex; align-items: center; justify-content: right;">
                        <div class="chat_btn" @click="goToUrl(item.redirectUrl)">Chat</div>
                    </van-col>
                </van-row>
            </div>
            <div class="chatText">{{ $t('contactService.text') }}
            </div>
        </div>
    </van-popup>
</template>

<script setup lang="ts">
import { ContactServiceData, goToUrl } from '@/view/profile/supportScript';
import { ref, defineProps, defineEmits, defineExpose, computed } from 'vue'


const props = defineProps<{
    dataSet: ContactServiceData
}>()

const emits = defineEmits(['open', 'close', 'update:show'])

const show = computed({
    get: () => props.dataSet.show,
    set: (val) => emits('update:show', val)
})
const open = () => {
    emits('open')
}
const close = () => {
    emits('close')
}

defineExpose({
    open,
    close
})

</script>
<style scoped>
.van-popup {
    -ms-overflow-style: none;
    scrollbar-width: none;
    overflow-y: auto;
    border-top-left-radius: 0rem !important;
    border-top-right-radius: 0rem !important;
    border: 1px solid rgba(255, 255, 255, 0.10) !important;
    box-shadow: 0 -4px 8px 0 rgba(0, 0, 0, 0.25), inset 0 1px 0 0 rgba(255, 255, 255, .25) !important;
    backdrop-filter: blur(25px) !important;
    padding-bottom: 100px;
}

.title {
    padding: 0px 15px;
    font-size: 14px;
    color: #ffa4d1;
    font-size: 18px;
    display: flex;
    justify-content: center;
    background: #312734;
    margin-bottom: 15px;
    font-weight: bold;
}

.title img {
    width: 50px;
}

.van-overlay {
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
    z-index: 10001 !important;
}

.van-popup::-webkit-scrollbar {
    display: none;
}

.chat_btn {
    color: #fff;
    font-size: 11.5px;
    background: linear-gradient(270deg, #e151a4, #e66fc8);
    border-radius: 5px;
    padding: 8px 20px;
    display: flex;
    align-items: center;
    display: flex;
    text-align: center;
    justify-content: center;
    width: 90%;
}

.chatText {
    color: #fff;
    padding: 15px;
    font-size: 15px;
}

.serviceCard {
    background: #3e2e4b;
    border: 0.5px solid rgba(221, 122, 51, 0.25);
    padding: 10px;
    border-radius: 10px;
    margin: 15px;
    border-radius: 5px;
}

.avatarImage img {
    width: 90%;
}

.serviceTitle {
    font-size: 13px;
    font-weight: 300;
    color: #fff;
    display: flex;
    align-items: center;

}

.serviceCard>>>.van-cell {
    padding: 5px 15px;
    margin: 10px 0;
    background: #ffffff29;
    color: #ffffff7a;
    font-size: 15px;
}

.serviceCard>>>.van-field__control {
    color: #ffffff7a;
    font-size: 15px;
}

.ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    width: 100%;
}
</style>